// extracted by mini-css-extract-plugin
export default {"principal":"Home_principal__W91RZ","sectionProcessos":"Home_sectionProcessos__jduMK","containerProcessos":"Home_containerProcessos__CJT9K"};